import { values } from '@fortem-monorepo/js-utilities';
export const SUB_FACTOR = {
    Agf: 'AGF',
    Amc: 'AMC',
    Arbitrage: 'Arbitrage',
    AssetSwap: 'Asset Swap',
    Backwardation: 'Backwardation',
    Benchmark: 'Benchmark',
    BondCarry: 'Bond Carry',
    BondCurve: 'Bond Curve',
    BondValue: 'Bond Value',
    BondVolatility: 'Bond Volatility',
    Carry: 'Carry',
    CommodityCarry: 'Commodity Carry',
    CommodityCongestion: 'Commodity Congestion',
    CommodityCurve: 'Commodity Curve',
    CommodityMomentum: 'Commodity Momentum',
    CommodityValue: 'Commodity Value',
    CommodityVolatility: 'Commodity Volatility',
    Congestion: 'Congestion',
    CreditCarry: 'Credit Carry',
    CreditVolatility: 'Credit Volatility',
    CrossAssetMomentum: 'Cross Asset Momentum',
    Curve: 'Curve',
    Dgf: 'DGF',
    Dispersion: 'Dispersion',
    Dividend: 'Dividend',
    EquitiesCarry: 'Equities Carry',
    EquitiesCongestion: 'Equities Congestion',
    EquitiesLiquidity: 'Equities Liquidity',
    EquitiesMomentum: 'Equities Momentum',
    EquitiesMultiFactor: 'Equities Multi Factor',
    EquitiesSize: 'Equities Size',
    EquitiesValue: 'Equities Value',
    EquitiesVolatility: 'Equities Volatility',
    Equity: 'Equity',
    EquityCarry: 'Equity Carry',
    EquityLowBeta: 'Equity Low Beta',
    EquityMomentum: 'Equity Momentum',
    EquityMultiStyle: 'Equity Multi-style',
    EquityQuality: 'Equity Quality',
    EquitySize: 'Equity Size',
    EquityValue: 'Equity Value',
    EquityVolatility: 'Equity Volatility',
    EuropeanEquityVolArb: 'European Equity Vol Arb',
    FxCarry: 'FX Carry',
    FxCongestion: 'FX Congestion',
    FxMomentum: 'FX Momentum',
    FxMultiFactor: 'FX Multi Factor',
    FxValue: 'FX Value',
    Gold: 'Gold',
    Hedging: 'Hedging',
    Intraday: 'Intraday',
    IntradayMomentum: 'Intraday Momentum',
    Long: 'Long',
    MeanReversion: 'Mean Reversion',
    MeanReversionHyphenated: 'Mean-Reversion',
    MultiFactor: 'Multi-Factor',
    Property: 'Property',
    RatesCarry: 'Rates Carry',
    RatesCurve: 'Rates Curve',
    RatesMomentum: 'Rates Momentum',
    RatesMultiStrat: 'Rates Multi -strat',
    RatesValue: 'Rates Value',
    RatesVolatility: 'Rates Volatility',
    Relative: 'Relative',
    SptrIndex: 'SPTR Index',
    Seasonality: 'Seasonality',
    Short: 'Short',
    Skew: 'Skew',
    Term: 'Term',
    TimeSeries: 'Time Series',
    Trend: 'Trend',
    UsEquityVolArb: 'US Equity Vol Arb',
    Usd: 'USD',
    Volatility: 'Volatility',
    XAssetMomentum: 'X Asset Momentum',
    XAssetVolatility: 'X Asset Volatility',
    XSectional: 'X-Sectional',
};
export const SUB_FACTORS = values(SUB_FACTOR);
